export default "__VITE_ASSET__OVfyR8mb__"